import {
  FDealType,
  FOfferType,
  TJsonQuery,
  dealTypeFromJsonQuery,
  getTermsValue,
  offerTypeFromJsonQuery,
} from 'shared/common/packages/JsonQuery';

type TAdfoxPuidParams = {
  puid1?: string;
  puid2?: string;
  puid5?: string;
};

export function getAdfoxPuidParams(jsonQuery: TJsonQuery): TAdfoxPuidParams {
  const params: TAdfoxPuidParams = {};

  // puid1 — тип сделки
  const dealType = dealTypeFromJsonQuery(jsonQuery);
  if (dealType & FDealType.Sale) {
    params.puid1 = 'deal_type_sale';
  } else if (dealType & FDealType.Rent) {
    params.puid1 = 'deal_type_rent';
  }

  // puid2 — тип объявления
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const puid2 = getOfferTypePuid2(offerType);
  if (puid2) {
    params.puid2 = puid2;
  }

  // puid5 — регион
  const regions = getTermsValue('region')(jsonQuery);
  if (regions?.[0]) {
    params.puid5 = `obl_id_${regions[0]}`;
  }

  return params;
}

function getOfferTypePuid2(offerType: FOfferType): string | undefined {
  if (offerType & FOfferType.Urban) {
    return 'offer_flat';
  }

  if (offerType & FOfferType.Suburban) {
    return 'offer_suburban';
  }

  if (offerType & (FOfferType.Commercial | FOfferType.Garage)) {
    return 'offer_commercial';
  }

  return undefined;
}
